// extracted by mini-css-extract-plugin
module.exports = {"regionsList":"coverage-map_regionsList__0KJsI","regionButton":"coverage-map_regionButton__WIX04"};